// External libraries
import React, { useState } from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import {
  CustomInputContainer,
  FloatingLabelInput,
  InfoIcon,
  Tooltip,
} from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import {
  customInputContainerStyles,
  inputContainerStyles,
  inputStyleOverrides,
  tooltipStyleOverrides,
} from './styles';
import { EmailAndTooltipContainer, InfoButton } from './StyledComponents';

const Email = props => {
  useMountLogging('Email');
  const emailState = useStoreState(({ form }) => form.email);
  const onboardOption = useStoreState(({ form }) => form.onboardOption);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false);
  const { blurHandler, focusHandler } = props;
  const { displayError, error, ...partialEmailState } = emailState;

  const buttonFocusAndBlurHandler = e => {
    const { type } = e;

    setIsTooltipDisplayed(type === 'focus');
  };

  return (
    <EmailAndTooltipContainer>
      <CustomInputContainer
        blurHandler={blurHandler}
        displayError={displayError}
        error={error}
        focusHandler={focusHandler}
        inputContainerStyleOverrides={customInputContainerStyles}
        inputId="email"
      >
        {focusAndBlurHandler => (
          <>
            <FloatingLabelInput
              autoComplete="email"
              blurHandler={focusAndBlurHandler}
              changeHandler={props.changeHandler}
              containerStyleOverrides={inputContainerStyles}
              disabled={isFormSubmitting}
              focusHandler={focusAndBlurHandler}
              hasError={displayError}
              id="email"
              inputStyleOverrides={inputStyleOverrides}
              label={getContent('fieldLabels.email')}
              name="email"
              required={true}
              type="email"
              {...partialEmailState}
            />
            <InfoButton
              id="emailInfoIcon"
              onBlur={buttonFocusAndBlurHandler}
              onFocus={buttonFocusAndBlurHandler}
              type="button"
            >
              <InfoIcon
                type={isTooltipDisplayed ? 'primaryActive' : 'primary'}
              />
            </InfoButton>
          </>
        )}
      </CustomInputContainer>
      {isTooltipDisplayed && (
        <Tooltip arrowPosition="top" styleOverrides={tooltipStyleOverrides}>
          {getContent(
            `messages.emailTooltip.${onboardOption.value || 'guest'}`,
          )}
        </Tooltip>
      )}
    </EmailAndTooltipContainer>
  );
};

Email.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
  focusHandler: func.isRequired,
};

export { Email };
